import React, { Component } from 'react';
import { Layout } from 'antd';
import TopbarWrapper from './topbar.style';

import logo from './logo.jpg';

const { Header } = Layout;

class Topbar extends Component {
  render() {
    const styling = {
      position: 'fixed',
      width: '100%',
      height: 70,
    };
    return (
      <TopbarWrapper>
        <Header style={styling} className="topbar">
          <div className="boxed">
            <img src={logo} alt="d'Arta"/>
          </div>
        </Header>
      </TopbarWrapper>
    );
  }
}

export default Topbar;


// WEBPACK FOOTER //
// ./src/components/Topbar/Topbar.js